const TEST_EMAIL_DOMAINS = ['@hopin.to', '@hopin.com', '@synthetics.dtdg.eu'];

export default TEST_EMAIL_DOMAINS;
